import _defineProperty from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Aug 08 2018
 * @author SKu
 */
import Input from '../Input/Input';
import SliderStyled from './styled/SliderStyled';
import logger from '../../../shared/logger';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import * as React from 'react';
import { Key } from '../../../shared/keyboard/Key';
import withValidation from '../withValidation';
import translate from '../../i18n/translate/translate';
/**
 * Create RangeSlider component
 */

/**
 * [See DOCS for rc-slider](https://react-component.github.io/slider/)
 */

var RangeSlider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RangeSlider, _React$PureComponent);

  function RangeSlider() {
    var _this;

    _classCallCheck(this, RangeSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeSlider).apply(this, arguments));
    _this.state = {
      inputValue: _this.props.defaultValue
    };
    /**
     * Changes values in inputs after dragging slider and set values on slider
     */

    _this.updateState = function (value) {
      _this.setState({
        inputValue: value
      }, function () {
        _this.props.onChange(value);
      });
    };
    /**
     *  @param orientation - if true - event has come from lowerbound input, if false - from upperbound
     */


    _this.getInputsValue = function (orientation) {
      var inputValue = _this.state.inputValue;
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;
      var validatedValue = inputValue;

      if (inputValue[0] < min) {
        validatedValue = [min, inputValue[1]];
      }

      if (inputValue[1] > max) {
        validatedValue = [inputValue[0], max];
      }

      if (inputValue[0] > inputValue[1] && orientation) {
        validatedValue = [inputValue[1], inputValue[1]];
      }

      if (inputValue[0] > inputValue[1] && !orientation) {
        validatedValue = [inputValue[0], inputValue[0]];
      }

      return validatedValue;
    };
    /**
     * Validate and sets values on slider after submitting inputs or focusout
     *  @param orientation - if true - event has come from lowerbound input, if false - from upperbound
     * @param e - event from input
     */


    _this.onKeyUp = function (orientation) {
      return function (e) {
        if (e.key === Key.Enter) {
          var validatedValue = _this.getInputsValue(orientation);

          _this.updateState(validatedValue);
        }

        e.preventDefault();
      };
    };
    /**
     * Function allows to change input of the lower bound
     * @param e - event from input
     */


    _this.onLowerBoundChange = function (e) {
      _this.setState({
        inputValue: [Number(e.target.value), _this.state.inputValue[1]]
      });
    };
    /**
     * Function allows to change input of the upper bound
     * @param e - event from input
     */


    _this.onUpperBoundChange = function (e) {
      _this.setState({
        inputValue: [_this.state.inputValue[0], Number(e.target.value)]
      });
    };
    /**
     * Function shows inputs if required & step === 1
     */


    _this.showInputs = function () {
      if (_this.props.step === 1) {
        return React.createElement("div", {
          className: "mt1 flex"
        }, React.createElement("div", {
          className: "w-30"
        }, React.createElement(Input, {
          type: "number",
          label: translate(_this.props.lowerBoundKey ? _this.props.lowerBoundKey : 'lowerBound'),
          value: _this.state.inputValue[0],
          onChange: _this.onLowerBoundChange,
          onKeyUp: _this.onKeyUp(true)
        })), React.createElement("div", {
          className: "flex-grow-1"
        }, "\xA0"), React.createElement("div", {
          className: "w-30"
        }, React.createElement(Input, {
          type: "number",
          label: translate(_this.props.upperBoundKey ? _this.props.upperBoundKey : 'upperBound'),
          value: _this.state.inputValue[1],
          onChange: _this.onUpperBoundChange,
          onKeyUp: _this.onKeyUp(false)
        })));
      }

      logger.info('Inputs work only with step === 1');
      return React.createElement(React.Fragment, null);
    };

    return _this;
  }

  _createClass(RangeSlider, [{
    key: "render",
    value: function render() {
      var _marks;

      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max,
          unit = _this$props2.unit;
      /**
       * Settings for marks
       */

      var marks = (_marks = {}, _defineProperty(_marks, this.props.min, React.createElement("strong", null, unit ? "".concat(min, " ").concat(unit) : min)), _defineProperty(_marks, this.props.max, React.createElement("strong", null, unit ? "".concat(max, " ").concat(unit) : max)), _marks);
      return React.createElement(SliderStyled, {
        className: "input-wrapper"
      }, React.createElement(Range, Object.assign({}, this.props, {
        value: this.props.value,
        allowCross: this.props.allowCross ? true : false,
        marks: this.props.marksEnabled ? marks : {},
        onChange: this.updateState
      })), this.props.inputsEnabled && this.showInputs());
    }
  }]);

  return RangeSlider;
}(React.PureComponent);

RangeSlider.defaultProps = {
  defaultValue: []
};
export default RangeSlider;
export var RangeSliderValidated = withValidation(RangeSlider);